export const uniqueBy = <T>(
  array: T[],
  keyExtractor: (item: T) => string,
): T[] => {
  const seenKeys = new Set<string>();
  return array.filter((item) => {
    const key = keyExtractor(item);
    if (seenKeys.has(key)) {
      return false;
    }
    seenKeys.add(key);
    return true;
  });
};
